export enum VehiclePlanningMode {
  AUTO = 'auto',
  MANUAL = 'manual',
}
